import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Box from '@material-ui/core/Box'
import TagSelectionInput from 'components/tag-selection-input'
import { useGroupEventTagOptions } from 'components/group-events/form-option-hooks'
import { useStyles } from '../styles'

const EventNameAndTags = () => {
  const { register, control, errors, watch } = useFormContext()
  const tagOptions = useGroupEventTagOptions()
  const classes = useStyles()
  const title = watch('title')

  return (
    <>
      <Box className={classes.fieldGroup}>
        <TextField
          name="title"
          label="Event name *"
          defaultValue={title}
          InputLabelProps={{ shrink: title ? true : undefined }}
          inputRef={register}
          error={!!errors.title}
          helperText={errors.title && 'This field is required'}
          variant="outlined"
          fullWidth
          className={classes.fieldInput}
        />
      </Box>
      <Box className={classes.fieldGroup}>
        <Typography className={classes.sectionHeading}>Event tags</Typography>
        <Typography className={classes.fieldHelper}>
          Tags help students find events that match what they&apos;re looking
          for.
        </Typography>
        <Controller
          name="tags"
          control={control}
          render={({ onChange, value }) => (
            <>
              <TagSelectionInput
                tags={tagOptions}
                value={value}
                onChange={onChange}
                allowToSelectImmutableTags={true}
              />
              {errors.tags ? (
                <Typography variant="caption" color="error">
                  {errors.tags.message}
                </Typography>
              ) : null}
            </>
          )}
        />
      </Box>
    </>
  )
}

export default EventNameAndTags
